(function () {
  'use strict';

  if (window.__EDME_WISHLIST_LOADED__) return;
  window.__EDME_WISHLIST_LOADED__ = true;

  var STORAGE_KEY = 'edme_wishlist_v1';
  var LEGACY_STORAGE_KEY = 'edme_wishlist_products';
  var cardRequestCache = new Map();

  function normalizeHandle(value) {
    return String(value || '')
      .trim()
      .replace(/^https?:\/\/[^/]+\/products\//i, '')
      .replace(/^\/products\//i, '')
      .split(/[?#/]/)[0]
      .toLowerCase();
  }

  function uniqueHandles(list) {
    var seen = Object.create(null);
    var result = [];

    (Array.isArray(list) ? list : []).forEach(function (item) {
      var handle = normalizeHandle(
        typeof item === 'string'
          ? item
          : item && (item.handle || item.url)
      );

      if (!handle || seen[handle]) return;
      seen[handle] = true;
      result.push(handle);
    });

    return result;
  }

  function readRawStorage(key) {
    try {
      return JSON.parse(localStorage.getItem(key) || '[]');
    } catch (error) {
      return [];
    }
  }

  function migrateLegacyWishlist() {
    var current = uniqueHandles(readRawStorage(STORAGE_KEY));
    if (current.length) return current;

    var legacy = uniqueHandles(readRawStorage(LEGACY_STORAGE_KEY));
    if (!legacy.length) return current;

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(legacy));
    } catch (error) {}

    return legacy;
  }

  function readWishlist() {
    return uniqueHandles(readRawStorage(STORAGE_KEY));
  }

  function writeWishlist(handles, detail) {
    var next = uniqueHandles(handles);

    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (error) {
      console.warn('[EDME Wishlist] Favoriler kaydedilemedi.', error);
    }

    updateAllButtons();

    document.dispatchEvent(new CustomEvent('edme:wishlist:change', {
      detail: Object.assign({ handles: next }, detail || {})
    }));

    return next;
  }

  function has(handle) {
    return readWishlist().indexOf(normalizeHandle(handle)) !== -1;
  }

  function add(handle) {
    handle = normalizeHandle(handle);
    if (!handle) return readWishlist();

    var handles = readWishlist().filter(function (item) {
      return item !== handle;
    });

    handles.unshift(handle);
    return writeWishlist(handles, { action: 'add', handle: handle });
  }

  function remove(handle) {
    handle = normalizeHandle(handle);

    return writeWishlist(
      readWishlist().filter(function (item) {
        return item !== handle;
      }),
      { action: 'remove', handle: handle }
    );
  }

  function toggle(handle) {
    handle = normalizeHandle(handle);
    return has(handle) ? remove(handle) : add(handle);
  }

  function clear() {
    return writeWishlist([], { action: 'clear' });
  }

  function setButtonState(button, active) {
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
    button.setAttribute('aria-label', active ? 'Favorilerden çıkar' : 'Favorilere ekle');
    button.title = active ? 'Favorilerden çıkar' : 'Favorilere ekle';
  }

  function updateAllButtons(scope) {
    var handles = readWishlist();

    (scope || document)
      .querySelectorAll('[data-edme-wishlist-toggle]')
      .forEach(function (button) {
        var handle = normalizeHandle(button.getAttribute('data-product-handle'));
        setButtonState(button, handles.indexOf(handle) !== -1);
      });
  }

  function animateButton(button) {
    button.classList.remove('is-bouncing');
    void button.offsetWidth;
    button.classList.add('is-bouncing');

    window.setTimeout(function () {
      button.classList.remove('is-bouncing');
    }, 460);
  }

  function rootUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function productUrl(handle) {
    return rootUrl() + 'products/' + encodeURIComponent(normalizeHandle(handle));
  }

  function parseConfig(root) {
    var node = root.querySelector('[data-edme-wishlist-config]');
    var defaults = { cardView: 'edme-favorite-card' };

    if (!node) return defaults;

    try {
      return Object.assign(defaults, JSON.parse(node.textContent || '{}'));
    } catch (error) {
      console.warn('[EDME Wishlist] Ayarlar okunamadı.', error);
      return defaults;
    }
  }

  function escapeSelector(value) {
    if (window.CSS && typeof window.CSS.escape === 'function') {
      return window.CSS.escape(String(value));
    }

    return String(value).replace(/(["'\\.#:[\],=])/g, '\\$1');
  }

  function createWishlistHeartMarkup() {
    return [
      '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">',
      '  <path d="M10 17.5C10 17.5 2.5 13 2.5 7.5C2.5 5.29086 4.29086 3.5 6.5 3.5C7.84 3.5 9.025 4.183 10 5.25C10.975 4.183 12.16 3.5 13.5 3.5C15.7091 3.5 17.5 5.29086 17.5 7.5C17.5 13 10 17.5 10 17.5Z" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>',
      '</svg>'
    ].join('');
  }

  function ensureWishlistButton(card, handle) {
    if (!card || !handle) return;

    var existing = card.querySelector('[data-edme-wishlist-toggle]');
    if (existing) {
      existing.setAttribute('data-product-handle', handle);
      setButtonState(existing, has(handle));
      return;
    }

    var media = card.querySelector('.edme-pcard__media, [data-pcard-media]');
    if (!media) return;

    var button = document.createElement('button');
    button.type = 'button';
    button.className = 'edme-wishlist-btn edme-pcard__wishlist';
    button.setAttribute('data-edme-wishlist-toggle', '');
    button.setAttribute('data-product-handle', handle);
    button.setAttribute('aria-pressed', 'true');
    button.setAttribute('aria-label', 'Favorilerden çıkar');
    button.title = 'Favorilerden çıkar';
    button.innerHTML = createWishlistHeartMarkup();

    media.appendChild(button);
    setButtonState(button, true);
  }

  function fetchRenderedProductCard(handle, viewName) {
    handle = normalizeHandle(handle);
    viewName = String(viewName || 'edme-favorite-card');

    var cacheKey = handle + '::' + viewName;
    if (cardRequestCache.has(cacheKey)) return cardRequestCache.get(cacheKey);

    var request = fetch(
      productUrl(handle) + '?view=' + encodeURIComponent(viewName),
      {
        method: 'GET',
        credentials: 'same-origin',
        headers: { 'Accept': 'text/html' }
      }
    ).then(function (response) {
      if (!response.ok) {
        var error = new Error('Ürün kartı yüklenemedi: ' + response.status);
        error.status = response.status;
        throw error;
      }

      return response.text();
    }).then(function (html) {
      var parser = new DOMParser();
      var documentNode = parser.parseFromString(html, 'text/html');
      var responseRoot = documentNode.querySelector('[data-edme-favorite-card-response]');
      var card = responseRoot
        ? responseRoot.querySelector('.edme-pcard')
        : documentNode.querySelector('.edme-pcard');

      if (!card) {
        throw new Error('edme-product-card HTML çıktısı bulunamadı.');
      }

      var importedCard = document.importNode(card, true);
      var productHandle = normalizeHandle(
        responseRoot && responseRoot.getAttribute('data-product-handle')
          ? responseRoot.getAttribute('data-product-handle')
          : handle
      );

      importedCard.setAttribute('data-edme-favorite-card', '');
      importedCard.setAttribute('data-product-handle', productHandle);
      importedCard.setAttribute(
        'data-product-title',
        String(
          responseRoot && responseRoot.getAttribute('data-product-title')
            ? responseRoot.getAttribute('data-product-title')
            : ''
        ).toLocaleLowerCase('tr-TR')
      );
      importedCard.setAttribute(
        'data-product-price',
        responseRoot && responseRoot.getAttribute('data-product-price')
          ? responseRoot.getAttribute('data-product-price')
          : '0'
      );

      /*
       * edme-product-card snippet'i kalp butonu içermiyorsa favoriler sayfasında
       * kartın görsel alanına ürün sayfasındaki kalbin aynısını ekle.
       */
      ensureWishlistButton(importedCard, productHandle);

      return importedCard;
    }).catch(function (error) {
      cardRequestCache.delete(cacheKey);
      throw error;
    });

    cardRequestCache.set(cacheKey, request);
    return request;
  }

  function setPageState(root, state) {
    var loading = root.querySelector('[data-edme-favorites-loading]');
    var products = root.querySelector('[data-edme-favorites-products]');
    var empty = root.querySelector('[data-edme-favorites-empty]');
    var error = root.querySelector('[data-edme-favorites-error]');

    if (loading) loading.hidden = state !== 'loading';
    if (products) products.hidden = state !== 'grid';
    if (empty) empty.hidden = state !== 'empty';
    if (error) error.hidden = state !== 'error';
  }

  function updatePageCount(root) {
    var count = root.querySelectorAll('[data-edme-favorite-card]').length;
    var countNode = root.querySelector('[data-edme-favorites-count-value]');
    var clearButton = root.querySelector('[data-edme-favorites-clear]');

    if (countNode) countNode.textContent = String(count);
    if (clearButton) clearButton.hidden = count === 0;

    return count;
  }

  function applySort(root) {
    var grid = root.querySelector('[data-edme-favorites-grid]');
    var select = root.querySelector('[data-edme-favorites-sort]');
    if (!grid || !select) return;

    var value = select.value;
    var cards = Array.prototype.slice.call(
      grid.querySelectorAll(':scope > [data-edme-favorite-card]')
    );

    cards.sort(function (a, b) {
      if (value === 'price-asc') {
        return Number(a.dataset.productPrice || 0) - Number(b.dataset.productPrice || 0);
      }

      if (value === 'price-desc') {
        return Number(b.dataset.productPrice || 0) - Number(a.dataset.productPrice || 0);
      }

      if (value === 'title-asc') {
        return String(a.dataset.productTitle || '').localeCompare(
          String(b.dataset.productTitle || ''),
          'tr'
        );
      }

      return Number(a.dataset.wishlistOrder || 0) - Number(b.dataset.wishlistOrder || 0);
    });

    cards.forEach(function (card) {
      grid.appendChild(card);
    });
  }

  function refreshProductCards(grid) {
    if (!grid) return;

    if (
      window.EDMECollection &&
      typeof window.EDMECollection.refresh === 'function'
    ) {
      window.EDMECollection.refresh(grid);
      return;
    }

    /* Eski collection JS sürümleri için güvenli geri dönüş. */
    var shell = grid.closest('[data-edme-collection]');
    var pageRoot = grid.closest('[data-edme-wishlist-page]');

    if (shell && pageRoot) {
      shell.__edmeInit = false;
      shell.querySelectorAll('.edme-pcard').forEach(function (card) {
        card.__edmeInit = false;
      });

      pageRoot.dispatchEvent(new Event('shopify:section:load', { bubbles: true }));
    }
  }

  function renderWishlistPage(root, options) {
    if (!root) return Promise.resolve();

    var config = parseConfig(root);
    var grid = root.querySelector('[data-edme-favorites-grid]');
    var handles = readWishlist();
    var keepExisting = Boolean(options && options.keepExisting);

    if (!grid) return Promise.resolve();

    if (!handles.length) {
      grid.innerHTML = '';
      updatePageCount(root);
      setPageState(root, 'empty');
      return Promise.resolve();
    }

    if (!keepExisting || !grid.children.length) {
      setPageState(root, 'loading');
    } else {
      setPageState(root, 'grid');
    }

    var existing = Object.create(null);

    grid.querySelectorAll(':scope > [data-edme-favorite-card]').forEach(function (card) {
      var handle = normalizeHandle(card.getAttribute('data-product-handle'));
      if (handle) existing[handle] = card;
    });

    Object.keys(existing).forEach(function (handle) {
      if (handles.indexOf(handle) === -1) {
        existing[handle].remove();
        delete existing[handle];
      }
    });

    var missing = handles.filter(function (handle) {
      return !existing[handle];
    });

    var requests = missing.map(function (handle) {
      return fetchRenderedProductCard(handle, config.cardView)
        .then(function (card) {
          return { handle: handle, card: card, error: null };
        })
        .catch(function (error) {
          return { handle: handle, card: null, error: error };
        });
    });

    return Promise.all(requests).then(function (results) {
      var failed = [];

      results.forEach(function (result) {
        if (!result.card) {
          failed.push(result);
          return;
        }

        existing[result.handle] = result.card;
      });

      var fragment = document.createDocumentFragment();
      var renderedCount = 0;

      handles.forEach(function (handle, index) {
        var card = existing[handle];
        if (!card) return;

        card.dataset.wishlistOrder = String(index);
        fragment.appendChild(card);
        renderedCount += 1;
      });

      grid.innerHTML = '';
      grid.appendChild(fragment);

      updateAllButtons(grid);
      refreshProductCards(grid);
      applySort(root);
      updatePageCount(root);

      if (renderedCount > 0) {
        setPageState(root, 'grid');
      } else if (failed.length) {
        console.error('[EDME Wishlist] Favori ürün kartları yüklenemedi.', failed);
        setPageState(root, 'error');
      } else {
        setPageState(root, 'empty');
      }
    }).catch(function (error) {
      console.error('[EDME Wishlist] Favoriler yüklenemedi.', error);
      setPageState(root, 'error');
    });
  }

  function initWishlistPage(root) {
    if (!root || root.__edmeWishlistPageInit) return;
    root.__edmeWishlistPageInit = true;

    var clearButton = root.querySelector('[data-edme-favorites-clear]');
    var sort = root.querySelector('[data-edme-favorites-sort]');
    var retry = root.querySelector('[data-edme-favorites-retry]');

    if (clearButton) {
      clearButton.addEventListener('click', function () {
        var message = clearButton.getAttribute('data-confirm-message') || 'Tüm favoriler silinsin mi?';
        if (window.confirm(message)) clear();
      });
    }

    if (sort) {
      sort.addEventListener('change', function () {
        applySort(root);
      });
    }

    if (retry) {
      retry.addEventListener('click', function () {
        cardRequestCache.clear();
        renderWishlistPage(root);
      });
    }

    renderWishlistPage(root);
  }

  function initAll(scope) {
    updateAllButtons(scope || document);

    (scope || document)
      .querySelectorAll('[data-edme-wishlist-page]')
      .forEach(initWishlistPage);
  }

  migrateLegacyWishlist();

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-edme-wishlist-toggle]');
    if (!button) return;

    event.preventDefault();
    event.stopPropagation();

    var handle = normalizeHandle(button.getAttribute('data-product-handle'));
    if (!handle) return;

    toggle(handle);
    animateButton(button);
  });

  document.addEventListener('edme:wishlist:change', function () {
    document.querySelectorAll('[data-edme-wishlist-page]').forEach(function (root) {
      renderWishlistPage(root, { keepExisting: true });
    });
  });

  window.addEventListener('storage', function (event) {
    if (event.key !== STORAGE_KEY) return;

    updateAllButtons();

    document.querySelectorAll('[data-edme-wishlist-page]').forEach(function (root) {
      renderWishlistPage(root, { keepExisting: true });
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target || document);
  });

  window.EDMEWishlist = {
    get: readWishlist,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    clear: clear,
    refresh: function () {
      initAll(document);
      document.querySelectorAll('[data-edme-wishlist-page]').forEach(function (root) {
        renderWishlistPage(root, { keepExisting: true });
      });
    },
    storageKey: STORAGE_KEY
  };
})();
